import { useState, type ImgHTMLAttributes } from 'react';

type CdnImageProps = ImgHTMLAttributes<HTMLImageElement>;

export function CdnImage({ src, alt, className, onError, ...rest }: CdnImageProps) {
  const [failed, setFailed] = useState(false);

  if (failed || !src) {
    return (
      <div
        className={['cdn-image-fallback bg-[#080808]', className].filter(Boolean).join(' ')}
        aria-hidden={alt ? undefined : true}
        role={alt ? 'img' : undefined}
        aria-label={alt}
      />
    );
  }

  return (
    <img
      src={src}
      alt={alt ?? ''}
      className={className}
      decoding="async"
      onError={(event) => {
        if (import.meta.env.DEV) {
          console.warn('[CdnImage] failed to load:', src);
        }
        setFailed(true);
        onError?.(event);
      }}
      {...rest}
    />
  );
}
